exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-parent { max-width: 100%; overflow: auto; direction: rtl; }\r\n.table-parent table tr td { text-align: left; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/mybills/mybills.component.css
// module id = ../../../../../src/app/components/mybills/mybills.component.css
// module chunks = 0